import "bootstrap/dist/css/bootstrap.min.css";
import { useState } from "react";

const TargetConfiguration = () => {
  // Sample data
  const [rows, setRows] = useState([
    {
      id: 1,
      period: "16-10-2024 to 16-10-2025 (Current)",
      empId: "3155",
    },
  ]);

  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (id) => {
    setOpenDropdown(openDropdown === id ? null : id);
  };

  const onViewEditTriggered = (mode, empId) => {
    // mode: 1=View, 0=Add/Update
    alert(`Mode: ${mode === 1 ? "View" : "Add/Update"}, EmpId: ${empId}`);
  };

  return (
    <div id="page-content" style={{ minHeight: "538px" }}>
      <div className="fw-bold" style={{borderBottom:'2px solid #90b732', color:'#90b732', fontSize:'16px', paddingBottom:'8px'}}>Target Configuration</div>
      <div id="report-area">
        <div id="rightpane" className="col-12">
          <div className="panel panel-default mt-2">
            <div className="panel-heading">
              <div>&nbsp;</div>
            </div>
            <div className="panel-body p-0">
              <div className="row">
                <div className="col-12">
                  <div className="table-responsive bg-">
                    <table
                      id="idListTable"
                      className="table table-striped table-hover"
                    >
                      <thead className="">
                        <tr >
                          <th style={{ textAlign: "center", width: "2%" }}>Sl No.</th>
                          <th style={{ textAlign: "center", width: "5%" }}>Empanelment Period</th>
                          <th style={{ textAlign: "center", width: "3%" }}>Op</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rows.map((row, index) => (
                          <tr key={row.id} className="clsRow">
                            <td style={{ textAlign: "left" }}>{index + 1}</td>
                            <td style={{ textAlign: "left" }}>{row.period}</td>
                            <td style={{ textAlign: "center", position: "relative" }}>
                              <img
                                src="https://tallyeducation.com/tallyweb/modules/lib/templates/resources/images/more-operations-icon.png"
                                alt="more"
                                style={{ cursor: "pointer" }}
                                onClick={() => toggleDropdown(row.id)}
                              />
                              {openDropdown === row.id && (
                                <ul
                                  className="dropdown-menu show"
                                  style={{ position: "absolute", right: 0 }}
                                >
                                  <li>
                                    <button
                                      className="dropdown-item"
                                      onClick={() => onViewEditTriggered(1, row.empId)}
                                    >
                                      View
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      className="dropdown-item"
                                      onClick={() => onViewEditTriggered(0, row.empId)}
                                    >
                                      Add/Update
                                    </button>
                                  </li>
                                </ul>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>  
    </div>
  );
};

export default TargetConfiguration;
